import { render, staticRenderFns } from "./PageIRE.vue?vue&type=template&id=f7cb787c&scoped=true"
import script from "./PageIRE.vue?vue&type=script&lang=js"
export * from "./PageIRE.vue?vue&type=script&lang=js"
import style0 from "./PageIRE.vue?vue&type=style&index=0&id=f7cb787c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cb787c",
  null
  
)

export default component.exports